import Accordion from '@/common/components/Accordion'
import ButtonLink from '@/common/components/ButtonLink'
import { formatCurrency, formatPercentage } from '@/common/utils/formatters'
import { UpdateFeeDetailsModal } from '@/features/privateCompanies/components/updateContract/UpdateFeeDetailsModal'
import { CompanyContractType } from '@/features/privateCompanies/types/companyContract.type'
import { CircleChevronDownIcon, DollarSignIcon } from 'lucide-react'

interface FeeDetailsProps {
  contract?: CompanyContractType
  companyKind?: string
  contractUpdatedAt?: number
}

export const FeeDetails = ({ contract, companyKind, contractUpdatedAt }: FeeDetailsProps) => {
  return (
    <Accordion
      defaultOpen
      name="fee_details"
      head={
        <div className="flex items-center gap-x-2">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateFeeDetailsModal
              contract={contract}
              companyKind={companyKind}
              contractUpdatedAt={contractUpdatedAt}
            />
          </div>

          <p className="text-white-800">Tarifas</p>
        </div>
      }
      triggerClassName="py-2"
      bodyClassName="pt-4 pb-0"
      body={
        <div className="flex flex-col gap-4">
          <p>Tarifas padrão</p>

          {contract?.contract_fees?.map((fee, index) => (
            <div key={fee.id} className="flex items-center gap-x-4">
              <div className="flex items-center gap-x-2">
                <CircleChevronDownIcon strokeWidth={1} className="size-5 text-white-400" />

                <div className="flex flex-col gap-y-0.5">
                  <p className="text-[10px] leading-3 font-light text-white-400 italic">Tarifa</p>

                  <ButtonLink
                    linkTo={`/fee-templates/${fee.fee_template.id}`}
                    operationKlassToCheckPermission='Admin::Billing::FeeTemplates::Show'
                    dataTestId='fee_template_clickable_link'
                    hoverBackgroundSize="small"
                  >
                    <p data-testid={`contract_fee_${index}_display_name`} className="text-xs">
                      {fee.fee_template.display_name}
                    </p>
                  </ButtonLink>
                </div>
              </div>

              <div className="flex items-center gap-x-1">
                <DollarSignIcon strokeWidth={1} className="size-5 text-white-400" />

                <div className="flex flex-col gap-y-0.5">
                  <p className="text-[10px] leading-3 font-light text-white-400 italic">Valor</p>
                  <p data-testid={`contract_fee_${index}_value`} className="text-xs text-white-800">
                    {fee.fee_template.calculate_as === 'percentage'
                      ? formatPercentage(Number(fee.value))
                      : formatCurrency(Number(fee.value))}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      }
    />
  )
}
